import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-8 md:py-12 border-t border-gray-800" data-id="element-137">
      <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-138">
        <h2 className="text-xl md:text-2xl font-black text-white mb-3 md:mb-4 tracking-tight" data-id="element-139">
          PROFESORADO RESUELTO™
        </h2>
        <p className="max-w-2xl mx-auto mb-6 md:mb-8 text-xs md:text-sm leading-relaxed" data-id="element-140">
          El kit de estudio N°1 para estudiantes del Profesorado de Educación
          Física en Argentina. Porque terminar el profesorado no debería
          costarte años de improvisación y materiales dispersos.
        </p>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mb-6 md:mb-8 text-xs md:text-sm font-medium text-gray-300" data-id="element-141">
          <a href="mailto:soporte.activadigitalok@gmail.com" className="hover:text-white transition-colors" data-id="element-142">
            soporte.activadigitalok@gmail.com
          </a>
          <span className="hidden sm:inline text-gray-700" data-id="element-143">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-144">
            @activadigital.store
          </a>
          <span className="hidden sm:inline text-gray-700" data-id="element-145">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-146">
            efacademico.activadigital.store
          </a>
        </div>

        <div className="text-[10px] md:text-xs text-gray-600 border-t border-gray-800 pt-6 md:pt-8" data-id="element-147">
          <p data-id="element-148">© Activa Digital™ 2026 — Todos los derechos reservados.</p>
          <p className="mt-1 md:mt-2" data-id="element-149">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}